import { render, staticRenderFns } from "./CardStyle2.vue?vue&type=template&id=a9e62e4a&scoped=true&"
import script from "./CardStyle2.vue?vue&type=script&lang=js&"
export * from "./CardStyle2.vue?vue&type=script&lang=js&"
import style0 from "./CardStyle2.vue?vue&type=style&index=0&id=a9e62e4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e62e4a",
  null
  
)

export default component.exports